'use strict';

module.exports = {
    getAdformConfig: function (key) {
        if (typeof window === 'undefined') {
            return null;
        }
        let config = window.jsAdfromConfig || {};
        if (!(key in config)) {
            // eslint-disable-next-line no-console
            console.warn(`SFCC warning - getConfig(key): "${key}" is not configured yet and is not ready for usage.`);
        }
        return config[key];
    }
};
